// @flow
import type { ERROR_TYPE, ID_TYPE } from './common';

export type GATE_TYPE = {
  id: number,
  name: string,
  ordinal: string,
  type: number,
};

export type GATES_FETCH_STARTED_TYPE = {
  type: 'GATES_FETCH_STARTED',
};
export const GATES_FETCH_STARTED = 'GATES_FETCH_STARTED';

export type GATES_FETCH_SUCCESS_TYPE = {
    type: 'GATES_FETCH_SUCCESS',
    payload: {
        entities: {[number]: GATE_TYPE},
        order: Array<number>,
        page?: number,
        next?: number,
        count?: number
    },
};
export const GATES_FETCH_SUCCESS = 'GATES_FETCH_SUCCESS';

export type GATE_FETCH_SUCCESS_TYPE = {
  type: 'GATE_FETCH_SUCCESS',
  payload: GATE_TYPE
};
export const GATE_FETCH_SUCCESS = 'GATE_FETCH_SUCCESS';

export type GATES_FETCH_FAILED_TYPE = {
    type: 'GATES_FETCH_FAILED',
    payload: ERROR_TYPE
};
export const GATES_FETCH_FAILED = 'GATES_FETCH_FAILED';

export type GATE_CREATE_STARTED_TYPE = {
  type: 'GATE_CREATE_STARTED',
  payload: GATE_TYPE
};

export const GATE_CREATE_STARTED = 'GATE_CREATE_STARTED';

export type GATE_CREATE_SUCCESS_TYPE = {
  type: 'GATE_CREATE_SUCCESS',
  payload: GATE_TYPE
};

export const GATE_CREATE_SUCCESS = 'GATE_CREATE_SUCCESS';

export type GATE_CREATE_FAILED_TYPE = {
  type: 'GATE_CREATE_FAILED',
  payload: ERROR_TYPE
};

export const GATE_CREATE_FAILED = 'GATE_CREATE_FAILED';

// REMOVE gates
export type REMOVE_GATE_STARTED_TYPE = {
  type: 'REMOVE_GATE_STARTED',
  payload: number
};
export const REMOVE_GATE_STARTED = 'REMOVE_GATE_STARTED';

export type REMOVE_GATE_SUCCEED_TYPE = {
  type: 'REMOVE_GATE_SUCCEED',
  payload: number
};
export const REMOVE_GATE_SUCCEED = 'REMOVE_GATE_SUCCEED';

export type REMOVE_GATE_FAILED_TYPE = {
  type: 'REMOVE_GATE_FAILED',
  payload: ERROR_TYPE
};
export const REMOVE_GATE_FAILED = 'REMOVE_GATE_FAILED';

export type GATE_SELECTED_TYPE = {
  type: 'GATE_SELECTED',
  payload: ID_TYPE,
};
export const GATE_SELECTED = 'GATE_SELECTED';

export type GATES_ACTION_TYPE =
  | GATES_FETCH_STARTED_TYPE
  | GATE_FETCH_SUCCESS_TYPE
  | GATES_FETCH_FAILED_TYPE
  | GATES_FETCH_SUCCESS_TYPE
  | REMOVE_GATE_STARTED_TYPE
  | REMOVE_GATE_FAILED_TYPE
  | REMOVE_GATE_SUCCEED_TYPE
  | GATE_SELECTED_TYPE;



// WEBPACK FOOTER //
// ./src/scripts/types/gates.js